import type { ReactNode } from 'react'

export type HeroProps = {
  title: string
  eyebrow?: string
  lede?: string
  audio?: string
  transcript?: string
  children?: ReactNode
}

export default function Hero({ title, eyebrow, lede, audio, transcript, children }: HeroProps) {
  return (
    <div className="slide-hero" data-archetype="hero">
      {eyebrow ? <p className="slide-hero__eyebrow">{eyebrow}</p> : null}
      <h1 className="slide-hero__title">{title}</h1>
      {lede ? <p className="slide-hero__lede">{lede}</p> : null}
      {audio ? (
        <div className="slide-hero__audio" style={{ marginTop: '1.5rem' }}>
          <audio autoPlay controls style={{ width: '100%', borderRadius: '0.5rem' }}>
            <source src={audio} type="audio/mpeg" />
            <p>Your browser does not support the audio element.</p>
          </audio>
        </div>
      ) : null}
      {transcript ? (
        <p className="slide-hero__transcript" style={{ marginTop: '0.75rem' }}>{transcript}</p>
      ) : null}
      {children}
    </div>
  )
}
